import { Button, Container, CssBaseline, makeStyles, TextField, Typography, Input, InputAdornment, InputLabel, IconButton, FormControl, Grid, List, ListItem, Box } from '@material-ui/core';
import { COLORS } from '../../shared/Theme';

import React, { Fragment, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { SIcon } from '../../shared/Icon';

import { useCookies } from 'react-cookie';
import { useSnackbar } from 'notistack';
import ToastStr from '../../request/toastStr';

import axios from 'axios';
import { admin as v_admin, basic, Values, SNACKBAR_TIME } from '../../request/values';

//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
	nanumSquare_regular: {
		fontFamily: 'NanumR',
	},
	background: {
		width: '100vw',
		height: '100vh',
		background: `url("/images/background.png")`,
	},
	content: {
		width: '100%',
		height: '100%',
		display: 'grid',
		gridTemplateColumns: '230px 1fr',
	},
	sidebar: {
		display: 'grid',
		gridTemplateRows: '60px 80px 100px 100px 100px 1fr',
		backgroundColor: `${COLORS.LIGHT_BLUE_GREY}`,
	},
	mainPage: {
		display: 'grid',
		gridTemplateRows: '60px 1fr',
	},
	title: {
		margin: 'auto 0px auto 35px',
		fontFamily: 'NanumR',
		fontSize: '1.5rem',
		fontWeight: 'bold',
		color: `${COLORS.WHITE}`,
	},
	logo: {
		display: 'flex',
		alignItems: 'center',
		border: 'solid white',
		borderWidth: '0px 0px 1px 0px',
		cursor: 'pointer',
		'& img': {
			width: 'auto',
			maxHeight: '50%',
			margin: '10px',
		},
		'& #name': {
			display: 'inline-block',
			margin: 'auto 0px auto 0px',
			fontFamily: 'NanumR',
			fontSize: '1.5rem',
			fontWeight: 'bolder',
		},
	},
	userinfo: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		border: 'solid white',
		borderWidth: '0px 0px 1px 0px',
		'& #name': {
			display: 'inline-block',
			fontFamily: 'NanumR',
			fontSize: '1.25rem',
			fontWeight: 'bolder',
		},
	},
	menu: {
		border: 'solid white',
		borderWidth: '0px 0px 1px 0px',
		'& ul': {
			marginTop: '10px',
			'& li': {
				fontSize: '1rem',
				fontWeight: 'bolder',
				color: `${COLORS.SLATE_GREY}`,
				'& ul': {
					listStyle: 'none',
					paddingLeft: '0px',
					'& li': {
						fontSize: '1rem',
						fontWeight: 'normal',
						margin: '0px',
						cursor: 'pointer',
					},
				},
			},
		},
	},
	navigator: {
		display: 'grid',
		gridTemplateColumns: '3fr 2fr',
		backgroundColor: `${COLORS.WATER_BLUE}`,
	},
	form: {
		display: 'flex',
		width: '100%',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
		margin: 'auto',
		gap: '5%',
		'& input': {
			width: '70%',
			height: '55%',
		},
		'& Button': {
			border: 'solid 1px',
		},
	},
	classList: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& #modifyClass': {
			padding: '5px 25px',
			margin: '1.5vh 0',
			color: `${COLORS.WHITE}`,
			borderRadius: '10px',
			backgroundColor: `${COLORS.PUMPKIN}`,
		},
	},
	table: {
		display: 'grid',
		gridTemplateRows: '1fr 7fr 1.5fr',
		width: '95%',
		height: '45vh',
		margin: '1% auto',
		border: 'solid 2px',
		borderRadius: '10px',
		backgroundColor: `${COLORS.WHITE}`,
		'& #downInfo': {
			border: 'none',
		},
	},
	tableTitle: {
		display: 'flex',
		alignItems: 'center',
		padding: '10px 15px',
		border: 'solid lightgray',
		borderWidth: '0 0 2px 0',
	},
	titleName: {
		fontSize: '1rem',
		fontWeight: 'bold',
		color: `${COLORS.SLATE_GREY}`,
	},
	tableInfo: {
		display: 'grid',
		gridTemplateRows: '1fr 1fr 1fr 10px',
		border: 'solid lightgray',
		borderWidth: '0 0 2px 0',
		'& #interests': {
			gridTemplateColumns: '1fr 1fr 1fr',
			gap: '0 15px',
		},
		'& input': {
			borderColor: 'black',
			borderRadius: '10px',
			maxHeight: '50px',
		},
		'& select': {
			padding: '5px',
			fontFamily: 'Nanumgothic',
			appearance: 'none',
		},
		'& #codeContainer': {
			display: 'grid',
			gridTemplateColumns: '1fr 150px',
			'& button': {
				borderRadius: '10px',
				margin: '0 auto',
				color: `${COLORS.WHITE}`,
				backgroundColor: `${COLORS.PUMPKIN}`,
			},
			'& #classCode': {
				margin: '0 15px 0 0',
			},
		},
	},
	infoContainer: {
		padding: '5px 30px',
		display: 'grid',
		gridTemplateRows: '30px 1fr',
	},
	buttonContainer: {
		display: 'grid',
		gridTemplateColumns: '1fr 10vw 3vw',
	},
	classInfo: {
		display: 'grid',
		gridTemplateColumns: '3fr 4fr 8fr 3fr',
		padding: '25px 0',
		backgroundColor: `${COLORS.LIGHT_GREY}`,
	},
	selectBox: {
		position: 'relative',
		width: '100%',
		height: '100%',
		borderRadius: '10px',
		border: '2px solid black',
	},
	select: {
		width: 'inherit',
		height: 'inherit',
		background: 'transparent',
		border: '0 none',
		outline: '0 none',
		padding: '0 5px',
		position: 'relative',
		zIndex: 3,
	},
	arrowIcon: {
		position: 'absolute',
		// backgroundColor: `${COLORS.WATER_BLUE}`,
		top: '0',
		right: '0',
		zIndex: 1,
		width: '40px',
		height: 'inherit',
		borderLeft: '2px solid black',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& img': {
			width: '50%',
		},
	},
	buttonLabel: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: `${COLORS.CHARCHOAL_GREY}`,
		fontSize: 18,
		fontFamily: 'NanumB',
		fontWeight: 'bold',
		lineHeight: '21px',
	},
}));

const SERVER = basic.server;

type iClassList = {
	class_code: string;
	init_stock: number;
	max_loan: number;
	interest: number;
	interest_time: number;
	interest_hms: string;
};

const HeadAdminModifyClass: React.FC<any> = (props) => {
	const classes = useStyles();

	const { member } = props;

	const history = useHistory();
	const state: any = history.location.state;
	const className = state.name;
	const classCode = state.code;
	const info = state.ClassList;

	const [initStock, setInitStock] = useState<any | null>();
	const [maxLoan, setMaxLoan] = useState<any | null>();
	const [interest, setInterest] = useState<any | null>();
	const [interestTime, setInterestTime] = useState<any | null>();
	const [interestHms, setInterestHms] = useState<any | null>();
	const [auth, setAuth] = useState<boolean>(false);

	const [cookies, setCookie, removeCookie] = useCookies();
	const { enqueueSnackbar, closeSnackbar } = useSnackbar();

	const valueChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;
		if (id == 'initStock') setInitStock(value);
		else if (id == 'maxLoan') setMaxLoan(value);
		else if (id == 'interest') setInterest(value);
		else if (id == 'interestTime') setInterestTime(value);
		else if (id == 'interestHms') setInterestHms(value);
	};

	const valueChangeHandler2 = (e: React.ChangeEvent<HTMLSelectElement>) => {
		const { value } = e.target;
		setInterestHms(value);
	};

	const searchClass = () => {
		let url = new URL(SERVER + v_admin.admin + v_admin.search_class);
		let params = { id: member.id.toString(), targetClassName: className.toString() };
		url.search = new URLSearchParams(params).toString();
		axios({
			method: 'GET',
			withCredentials: true,
			url: url.toString(),
		})
			.then((res) => {
				return res.data;
			})
			.then((data: any) => {
				console.log('data?', data);
				if (data.code == Values.SUCCESS_CODE) {
					document.getElementById('initStock')?.setAttribute('value', data.data[0].init_stock);
					setInitStock(data.data[0].init_stock);
					document.getElementById('maxLoan')?.setAttribute('value', data.data[0].max_loan);
					setMaxLoan(data.data[0].max_loan);
					document.getElementById('interest')?.setAttribute('value', data.data[0].interest);
					setInterest(data.data[0].interest);
					document.getElementById('interestTime')?.setAttribute('value', data.data[0].interest_time);
					setInterestTime(data.data[0].interest_time);

					console.log(data.data[0].interest_hms);
					setInterestHms(data.data[0].interest_hms);
					switch (data.data[0].interest_hms) {
						case 'H':
							document.getElementById('h')?.setAttribute('selected', 'selected');
							break;
						case 'M':
							document.getElementById('m')?.setAttribute('selected', 'selected');
							break;
						case 'S':
							document.getElementById('s')?.setAttribute('selected', 'selected');
							break;
					}
				}
			});
	};

	const classModify = (event: any) => {
		console.log(initStock, maxLoan, interest, interestTime);
		if (isNaN(initStock) || isNaN(maxLoan) || isNaN(interest) || isNaN(interestTime)) enqueueSnackbar(ToastStr.CHECK_MONEY_INFO_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
		else {
			axios({
				method: 'POST',
				data: {
					classCode: classCode,
					initStock: initStock,
					maxLoan: maxLoan,
					interest: interest,
					interestTime: interestTime,
					interestHms: interestHms,
				},
				withCredentials: true,
				url: SERVER + v_admin.admin + v_admin.update_class,
			})
				.then((res) => {
					return res.data;
				})
				.then((data: any) => {
					console.log(data);
					if (data.code == Values.SUCCESS_CODE) {
						history.push({
							pathname: '/headAdminClassManage',
						});
					} else {
						if (data.code == Values.FAIL_CODE) {
							enqueueSnackbar(ToastStr.CLASS_CREATE_FAIL_STR, { variant: 'warning', autoHideDuration: SNACKBAR_TIME });
						} else {
							enqueueSnackbar(ToastStr.REQUEST_GET_POST_FAIL_STR, { variant: 'error', autoHideDuration: SNACKBAR_TIME });
						}
					}
				});
		}
	};

	const moveMaterialList = () => {
		history.push('/headAdminMaterialList');
	};
	const moveProductList = () => {
		history.push('/headAdminLicenseList');
	};
	const moveClassList = () => {
		history.push('/headAdminClassList');
	};
	const moveClassManage = () => {
		history.push('/headAdminClassManage');
	};
	const moveMemberList = () => {
		history.push('/headAdminMemberList');
	};
	const moveAccountManage = () => {
		history.push('/headAdminAccountManage');
	};

	useEffect(() => {
		searchClass();
	}, []);
	return (
		<div className={classes.background}>
			<CssBaseline />
			<div className={classes.content}>
				<div className={classes.sidebar}>
					<div className={classes.logo} onClick={(e) => moveClassList()}>
						<img src="/images/p.webp"></img>
						<Typography id="name">플레이스타트업</Typography>
					</div>
					<div className={classes.userinfo}>
						<Typography id="name">{member.name}님, 환영합니다!</Typography>
					</div>
					<div className={classes.menu}>
						<ul>
							<li>
								품목 관리
								<ul>
									<li onClick={(e) => moveMaterialList()}>재료 목록</li>
									<li onClick={(e) => moveProductList()}>제품 목록</li>
								</ul>
							</li>
						</ul>
					</div>
					<div className={classes.menu}>
						<ul>
							<li>
								교육 관리
								<ul>
									<li onClick={(e) => moveClassList()}>교육 목록</li>
									<li onClick={(e) => moveClassManage()}>교육 관리 목록</li>
								</ul>
							</li>
						</ul>
					</div>
					<div className={classes.menu}>
						<ul>
							<li>
								회원 관리
								<ul>
									<li onClick={(e) => moveMemberList()}>회원 목록</li>
									<li onClick={(e) => moveAccountManage()}>기업 계정 관리</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<div className={classes.mainPage}>
					<div className={classes.navigator}>
						<div className={classes.title}>클래스 수정</div>
						<div className={classes.form}></div>
					</div>
					<div className={classes.classList}>
						<div className={classes.table}>
							<div className={classes.tableTitle}>
								<Typography className={classes.titleName}>자금 정보 입력</Typography>
							</div>
							<div className={classes.tableInfo} id="downInfo">
								<div className={classes.infoContainer}>
									<script>console.log(ClassList);</script>
									<Typography>기업 초기 자본금</Typography>
									<input type="text" id="initStock" onChange={valueChangeHandler}></input>
								</div>
								<div className={classes.infoContainer}>
									<Typography>최대 대출 금액</Typography>
									<input type="text" id="maxLoan" onChange={valueChangeHandler}></input>
								</div>
								<div className={classes.infoContainer} id="interests">
									<Typography>이자율</Typography>
									<Typography>이자 주기</Typography>
									<Typography>단위 설정(시,분,초)</Typography>
									<input type="text" id="interest" onChange={valueChangeHandler}></input>
									<input type="text" id="interestTime" onChange={valueChangeHandler}></input>
									<div className={classes.selectBox}>
										<select className={classes.select} id="interestHMS" onChange={valueChangeHandler2}>
											<option value=""></option>
											<option id="h" value="H">
												시
											</option>
											<option id="m" value="M">
												분
											</option>
											<option id="s" value="S">
												초
											</option>
										</select>
										<span className={classes.arrowIcon}>
											<img src="/images/down_blue.webp" />
										</span>
									</div>
								</div>
							</div>
							<div className={classes.buttonContainer}>
								<div></div>
								<Button id="modifyClass" onClick={classModify}>
									<Typography>수정하기</Typography>
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default HeadAdminModifyClass;
